exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.is-danger{\n    border-color: red !important;\n}\n.modal-content{\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    margin-top: 50%;\n}\n.modal-header{\n    width: 0;\n    height: 0;\n}\n.disable{\n    cursor: not-allowed;\n    pointer-events: none;\n\n    /*Button disabled - CSS color class*/\n    color: #c0c0c0;\n    background-color: #FFC192 !important;\n}\n.el-dialog__headerbtn{\n    display: none !important;\n}\n@media (max-width: 767px) {\n.room-info{\n        display: none\n}\n}\n@media (min-width: 767px) {\n.top-room-info{\n        display: none\n}\n}\n\n\n", ""]);

// exports
